<!-- <div class="container">
  <div class="contact-page">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 sidebar">
        <app-side-menu></app-side-menu>
      </div> -->
      <div class="lrpadding15 contact-page row homebanner-holder">
        <ngx-slick-carousel *ngIf="bannerindashboard=='1' && homebannerList!=undefined && homebannerList.length>0" class="carousel home-banner" #slickModal="slick-carousel" [config]="slideConfig">
          <div ngxSlickItem *ngFor="let slide of homebannerList; let index=index" class="slide">
            <a *ngIf="slide.targeturl!=undefined && slide.targeturl!=null && slide.targeturl!=''" target="_blank" href="{{slide.targeturl}}">
              <img src="{{slide.ImageUrl}}" alt="{{slide.Title +''+ slide.Description}}" width="100%">  
            </a>
            <img *ngIf="slide.targeturl==undefined || slide.targeturl==null || slide.targeturl==''" src="{{slide.ImageUrl}}" alt="{{slide.Title +''+ slide.Description}}" width="100%">
            <div class="carousel-caption">
              <span class="big-text">{{slide.Title}}</span>
              <div class="excerpt"> <span>{{slide.Description}}</span> </div>  
              <div class="excerpt"> <a *ngIf="slide.targeturl!=undefined && slide.targeturl!=null && slide.targeturl!=''" target="_blank" href="{{slide.targeturl}}"><button type="submit" class="btn-upper btn btn-primary checkout-page-button" *ngIf="slide.linkname!=undefined && slide.linkname!=null && slide.linkname!=''">{{slide.linkname}}</button></a> </div>  
            </div>          
          </div>
        </ngx-slick-carousel>
        <br />
        <div class="col-xs-12 col-sm-12 col-md-12" *ngIf="UserType!=4">
          <h1 class="displaynone">Dashboard</h1>
          <div *ngIf="UserType==2">
            <h3>CHOOSE A CUSTOMER</h3>
            <ngx-select-dropdown [config]="config" [options]="customerlist" 
            [multiple]="false"
            (change)="customerChange($event.value)"
            [(ngModel)]="customer" ></ngx-select-dropdown>
            <!-- <select class="form-control unicase-form-control text-input" [(ngModel)]='customer' [ngModelOptions]="{standalone:true}"
              (change)="customerChange($event.target.value)">
            
               <option value=undefined>Select Customer</option>
              <option *ngFor="let c1 of customerlist" [value]="c1.customer1">{{c1.customer1}} - {{c1.name}} </option>
            </select> -->
            
            <!-- <ng-multiselect-dropdown   *ngIf="customerlist!=undefined && customerlist!=null && customerlist.length>0"         
              [ngModelOptions]="{standalone:true}" 
[placeholder]="'Select Customer'"
[data]="customerlist"
[(ngModel)]="customer"
[settings]="dropdownSettings1"
(onSelect)="customerChange($event.target.value)">
</ng-multiselect-dropdown>  -->
            <br />
            <div *ngIf="custdetails!=null">
              <div class="panel panel-default checkout-step-02">
                <div class="panel-heading fs16">
                  <h4 class="unicase-checkout-title">
                    <a data-toggle="collapse" class="collapsed" data-parent="#accordion" href="#collapseTwo">
                      <h2>{{custdetails.name}}</h2>
                    </a>
                  </h4>
                </div>
              </div>
              <div id="collapseTwo" class="panel-collapse collapse">
                <h3>Billing Address </h3>
                <span>{{custdetails.adr}},
                  <br />{{custdetails.state}}, {{custdetails.postal_code}} {{custdetails.country_code}}
                  <br /> {{custdetails.phone}} </span>
                <br />
                <br />
                <h3>Available Contacts</h3>
                <table class="width80per">
                  <tr *ngFor="let con1 of contactDetails">
                    <td>{{con1.name}}</td>
                    <td>{{con1.titled}}</td>
                    <td>{{con1.phone}}</td>
                    <td>{{con1.phone_ext}}</td>
                    <td>{{con1.email}}</td>
                  </tr>
                </table>
                <br />
                <h3>Profile Details</h3>
                <table class="width50per">
                  <tr *ngFor="let pro1 of profileinfo">
                    <td>{{pro1.Label}}</td>
                    <td>{{pro1.text}}</td>
                  </tr>
                </table>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div class="row dash-block" *ngIf="UserType!=4">
          
          <div (click)="redirectCategory()" class="col-md-4 col-sm-12 col-xs-12" id="categorydashboard" *ngIf="webtype!=1 && isShowCategory=='1'">
            <div class="dashbutton">
              <i class="fa fa-list-alt fa-3x" aria-hidden="true"></i>
              <span class="dashspan">Browse {{categorylabel}} </span>
            </div>
          </div>

          <div (click)="gotoProduct()" class="col-md-4 col-sm-12 col-xs-12" id="brandsdashboard" *ngIf="webtype!=1 && isShowCategory!='1'">
            <div class="dashbutton">
            <i class="fa fa-search fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Browse {{productlabel}} </span>
          </div>
          </div>

          <div (click)="gotoAdvancesearch()" class="col-md-4 col-sm-12 col-xs-12" id="advancedSearchdashboard" *ngIf="webtype!=1">
            <div class="dashbutton">
            <i class="fa fa-search fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Advanced Search </span>
          </div>
          </div>
       
         
         <div (click)="gotocart()" id="SeeMyShoppingCartdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="webtype!=1">
          <div class="dashbutton">
            <i class="fa fa-shopping-cart fa-3x" aria-hidden="true"></i>
            <span class="dashspan">See My Shopping Cart</span>
          </div>
          </div>
       <div (click)="Changepwd()" id="ChangePassworddashboard" class="col-md-4 col-sm-12 col-xs-12">
        <div class="dashbutton">
            <i class="fa fa-key fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Change Password</span>
          </div>
          </div>

          <div (click)="pendingOrder()" id="PendingOrdersdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowPendingOrders && isShowPendingOrdersConf">
            <div class="dashbutton">
            <i class="fa fa-clipboard fa-3x" aria-hidden="true"></i>
            <span class="dashspan" *ngIf="isrfqshow=='1'">Pending Orders & Quotes</span>
            <span class="dashspan" *ngIf="isrfqshow!='1'">Pending Orders</span>
          </div>
          </div>
          <div (click)="openshipments()" id="openshipmentsdb" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowopenshipment && isShowopenshipmentConf">
            <div class="dashbutton">
            <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Open Shipments</span>
          </div>
          </div>
          <div (click)="opentransfer()" id="opentransfer" class="col-md-4 col-sm-12 col-xs-12">
            <div class="dashbutton">
            <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Orders Due In</span>
          </div>
          </div>
          <div (click)="backorders()" id="BackOrderItemsdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowBackOrders && isShowBackOrdersConf">
            <div class="dashbutton">
            <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Back Order Items</span>
          </div>
          </div>
          <div (click)="Helpdeskclick()" id="HelpDeskdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowHelpDeskConf">
            <div class="dashbutton">
            <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Help Desk</span>
          </div>
          </div>

        
          <div (click)="invoices()" id="OpenInvoicesdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowOpenInvoice && isShowOpenInvoiceConf">
            <div class="dashbutton">
            <i class="fa fa-file-text-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Open Invoices</span>
          </div>
          </div>
          <div (click)="orderhistory()" id="OrderHistorydashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowOrderHistory && isShowOrderHistoryConf">
            <div class="dashbutton">
            <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Order History</span>
          </div>
          </div>
          <div (click)="ContractList()" id="customerproductdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowContractList && isShowContractListConf">
            <div class="dashbutton">
            <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
            <span class="dashspan">{{customerlable}}</span>
          </div>
          </div>
       
          
          <div (click)="purchasehistory()" id="PurchaseHistorydashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="isShowPurchaseHistory && isShowPurchaseHistoryConf">
            <div class="dashbutton">
            <i class="fa fa-clipboard fa-3x" aria-hidden="true"></i>
            <span class="dashspan">{{puchasehistorylable}}</span>
          </div>
          </div>
          <div (click)="reviewOrder()" id="ReviewUsersOrdersdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="(UserType=='1' || ismanager=='True' || ismanager=='true' || ismanager==true) && webtype!=1 && ismulti=='1'">
            <div class="dashbutton">
            <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
            <span class="dashspan">Review Users Orders</span>
          </div>
          </div>
        
          <div (click)="gotowish()" id="WishListdashboard" class="col-md-4 col-sm-12 col-xs-12" *ngIf="(webtype=='5' || webtype=='6') && iswishshow=='1'">
            <div class="dashbutton">
            <i class="fa fa-list-alt fa-3x" aria-hidden="true"></i>
            <span class="dashspan">{{wishlistlable}}</span>
          </div>
          </div>
          <div *ngIf="(webtype=='5' || webtype=='6') && isrfqshow=='1'" id="RFQListdashboard" (click)="gotorfq()" class="col-md-4 col-sm-12 col-xs-12">
            <div class="dashbutton">
            <i class="fa fa-list-ul fa-3x" aria-hidden="true"></i>
            <span class="dashspan">RFQ List</span>
          </div>
          </div>
          <div *ngIf="(webtype=='5' || webtype=='6') && IsRMA=='1'" id="rmadashboard" (click)="gotorma()" class="col-md-4 col-sm-12 col-xs-12">
            <div class="dashbutton">
            <i class="fa fa-list-ul fa-3x" aria-hidden="true"></i>
            <span class="dashspan">{{RMALable}}</span>
          </div>
          </div>

       
          <div *ngIf="(webtype=='5' || webtype=='6') && (UserType=='1' || isShowuserSupport) && ismulti=='1'" id="UserAccountSetupdashboard" (click)="gotouser()" class="col-md-4 col-sm-12 col-xs-12">
            <div class="dashbutton">
            <i class="fa fa-user-circle-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">User Account Setup</span>
          </div>
          </div>

          <div  id="UserProfiledashboard" (click)="gotouserprofile()" class="col-md-4 col-sm-12 col-xs-12">
            <div class="dashbutton">
            <i class="fa fa-user-circle-o fa-3x" aria-hidden="true"></i>
            <span class="dashspan">User Profile</span>
          </div>
          </div>

          <div *ngFor="let hlink of dashboardlinks" class="col-md-4 col-sm-12 col-xs-12">
            <a [routerLink]="[hlink.linkurl.toLowerCase()]" *ngIf="hlink.popover && hlink.linkurl.indexOf('http')==-1" target="_blank">
              <div class="dashbutton">
                <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
              <span class="dashspan">{{hlink.linkname}} </span>
            </div>
            </a>
            <a href="{{hlink.linkurl}}" *ngIf="hlink.popover && hlink.linkurl.indexOf('http')>-1" target="_blank">
              <div class="dashbutton">
                <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
              <span class="dashspan">{{hlink.linkname}} </span>
            </div>
            </a>
            <a [routerLink]="[hlink.linkurl.toLowerCase()]" *ngIf="!hlink.popover && hlink.linkurl.indexOf('http')==-1">
              <div class="dashbutton">
                <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
              <span class="dashspan">{{hlink.linkname}} </span>
            </div>
            </a>
            <a href="{{hlink.linkurl}}" *ngIf="!hlink.popover && hlink.linkurl.indexOf('http')>-1">
              <div class="dashbutton">
                <i class="fa fa-file-text fa-3x" aria-hidden="true"></i>
              <span class="dashspan">{{hlink.linkname}} </span>
            </div>
            </a>


            
              
          
          
          

        </div>
       
      </div>
    </div>
  <!-- </div>
</div> -->